import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const pluginKey: PluginKey = new PluginKey('helpDialogPlugin');
